const Reflux = require('@muzzylane/reflux');
const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');

const CollaboratorActions = Reflux.createActions({
    getProjectCollabs: { children: ['completed', 'failed'] },
    getChannelProjectsCollabs: { children: ['completed', 'failed'] },
    setProjectPermission: { children: ['completed', 'failed'] },
    deleteProjectPermission: { children: ['completed', 'failed'] }
});

CollaboratorActions.getProjectCollabs.listen(function(actionId, params) {
    const self = this;

    if (!params.projectID) {
        this.failed(actionId, params.projectID, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/projects/${params.projectID}/users`, 'GET')
        .then(function(res) { self.completed(actionId, params.projectID, res) })
        .catch(function(err) { self.failed(actionId, params.projectID, err) });
});

CollaboratorActions.getChannelProjectsCollabs.listen(function(actionId, params) {
    const self = this;

    if (!params.channelId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/channels/${params.channelId}/projects/users`, 'GET')
        .then(function(res) { self.completed(actionId, res) })
        .catch(function(err) { self.failed(actionId, err) });
});

CollaboratorActions.setProjectPermission.listen(function(actionId, params) {
    var self = this;

    if (!params.projectID) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.email && !params.userId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS, uiRefs: ['email'] }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/projects/${params.projectID}/permission`, 'POST', JSON.stringify({
            userId: params.userId || params.email,
            role: params.role,
            roleToken: params.roleToken
        }))
        .then(function(res) { self.completed(actionId, params.projectID, res); })
        .catch(function(err) { self.failed(actionId, params.projectID, err); });
});

CollaboratorActions.deleteProjectPermission.listen(function(actionId, params) {
    var self = this;

    if (!params.projectID) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.email && !params.userId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS, uiRefs: ['email'] }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/projects/${params.projectID}/permission`, 'POST', JSON.stringify({
            userId: params.userId || params.email,
            role: 0
        }))
        .then(function(res) { self.completed(actionId, params.projectID, res); })
        .catch(function(err) { self.failed(actionId, params.projectID, err); });
});

module.exports = CollaboratorActions;